import { createSelector } from "reselect";

import getUser from "../base_getters/get_user";

const getUserAccount = createSelector([
  getUser
], (user) => user?.account || null)

export default getUserAccount;
